import { Component, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';

import { AuthenticationService, AuthTrackingService } from '@core/services';

import { ProxyService, ConfirmModalService, ModalService, AlertService } from '@core/services';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Constants } from '@core/constants/core.constants';
import { TokenType } from '@shared/models/configs/social-auth.configs';

@Component({
  selector: 'app-term-n-condition',
  templateUrl: './term-n-condition.component.html',
  styleUrls: ['./term-n-condition.component.less'],
  providers: [AlertService]
})
export class TermNConditionComponent implements OnDestroy {

  public isAgree: boolean;
  private subscriptions = new Subscription();
  public successResponse: string;
  public loading: boolean;
  isGuestSignUp = false;
  returnUrl: string;

  constructor(
    private proxy: ProxyService,
    private confirmModalService: ConfirmModalService,
    private modalService: ModalService,
    private alertService: AlertService,
    private registrationService: AuthenticationService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authTracking: AuthTrackingService
  ) {
    this.isAgree = false;
    this.getTermsAndConditionsText();
    this.loading = false;

    this.subscriptions.add(
      this.confirmModalService.btnEvent.subscribe(
        () => {
          this.modalService.hideModal();
        }
      )
    );
    this.modalService.modalOptions.subscribe(succ=>
      {
        if(succ === Constants.GUEST_SIGNUP)
        {
          this.isGuestSignUp=true;
        }
       
      })
      this.subscriptions.add(
        this.activatedRoute.queryParams.subscribe(
          (params: Params) => {
            this.returnUrl = params[Constants.RETURN_URL] as string;
            if (this.returnUrl) {
              this.returnUrl = decodeURIComponent(this.returnUrl);
            }
          }
        )
      );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  showModal(name: string, autoHide: boolean = true) {
    this.modalService.setModalSelector(name);
    this.modalService.showModal(autoHide);
  }

  showSignupModal(): void {
    this.showModal(this.modalService.getSignupModalSelector(), false);
  }

  private getTermsAndConditionsText() {
    const reqParams = 'terms-conditions';
    this.proxy.httpGet(ApiRoutes.AUTH_TERMSANDCONDITIONS + reqParams).subscribe(
      (success) => {
        this.successResponse = success.body.valueOf().toString();
        this.cdr.detectChanges();
      },
      (err) => {
        // technically status 200 is a "success" and not an error to the server. Although the
        // it is technically an http error code so shows here.
        if (err.status === 200) {
          this.successResponse = err.error.text;
        }
        this.alertService.error(err.error.message);
        this.cdr.detectChanges();
      }
    );
  }

  async onTermsAccepted() {
    this.loading = true;
    this.cdr.detectChanges();
    if (this.registrationService.isReady()) {
      const routerUrl = this.router.url.toString();
      if (routerUrl.indexOf('/ordering/checkout') !== -1) {
        this.registrationService.setRegisterSignIn(true);
        this.router.navigate(['/ordering/checkout/payment']);
      }
      await this.registrationService.completeRegistration(true);
      if (this.registrationService.getErrorMessage() !== null) {
        const message = this.registrationService.getErrorMessage();
        const header = this.registrationService.getErrorHeader() === null
          ? 'Sign up error occurred' : this.registrationService.getErrorHeader();
        this.showConfirmErr(header, message);
        this.loading = true;
        this.cdr.detectChanges();
      } else {
        sessionStorage.removeItem('signUpForm');
        // if (this.registrationService.getEmailVerificationStatus(false)) {
        //   this.showConfirmSuccess();
        // }
        this.modalService.hideModal();
        const extRequest = this.registrationService.getExternalRequest();
        if(extRequest?.accessTokenType == TokenType.APPLE) {
          this.registrationService.cleanUpAppleSigninQueryParams();
        }
      }
      if(this.router.url.indexOf(this.authTracking.DELETE_ACCOUNT_ROUTE) !== -1) {
        this.authTracking.clearSignedOutUserEmail();
        this.router.navigateByUrl('/home');
      }
      if (this.returnUrl) {
        // TODO: this could have consequences - test this thoroughly
        this.router.navigateByUrl(this.returnUrl);
      }
    }
  }

  private showConfirmSuccess() {
    this.confirmModalService.show(
      'You\'re Almost Done',
      '',
      'Look for an email from us. Then all you have to do is tap on the link to confirm your email address,'
      + ' and you\'ll be all set to pay for orders.',
      'OK, Got It'
    );
  }

  private showConfirmErr(header: string, message: string) {
    this.confirmModalService.show(
      header,
      '',
      JSON.stringify(message),
      'OK, Got It'
    );
  }
}
